import { navigate, subscribe } from './featured-content/featured-content-service';
import { collectFilters } from './featured-filter';
import * as templates from './featured-content/featured-content-templates';
import GLightbox from 'glightbox';
import { get } from '../utils/options';
import { selector as featuredItemEventSelector, FeaturedItemEvent } from './featured-content/featured-item-event';

const selectors = {
  component: '.c-featured-content',
  heading: '.c-featured-content__heading',
  items: '.c-featured-content__items',
  aside: '.c-featured-content__aside',
  noResults: '.c-featured-content__no-results',
  subNavigation: '.c-featured-navigation-sub',
  backButton: '.c-featured-content__back',
  loader: '.c-loader-overlay',
  dynamicContent: '.c-featured-content--dynamic-content',
  sort: '.c-featured-content__sort',
};

export const collectSort = () => {
  const $sort = document.querySelector(selectors.sort)

  if(!$sort) return

  return $sort.value
};


export class FeaturedContent {
  id = new URLSearchParams(document.location.search).get('id');
  page = 1;

  itemsContainer;
  static backButton;
  loadMoreButton;

  constructor($el) {
    this.component = $el
    this.itemsContainer = $el.querySelector(selectors.items)
    this.asideContainer = $el.querySelector(selectors.aside)
    this.headingContainer = $el.querySelector(selectors.heading)
    this.loader = $el.querySelector(selectors.loader)
    this.dynamicContent = $el.querySelectorAll(selectors.dynamicContent)
    this.noResults = $el.querySelector(selectors.noResults)
    this.sort = $el.querySelector(selectors.sort)

    FeaturedContent.backButton = $el.querySelector(selectors.backButton);
    FeaturedContent.loader = this.loader;
    FeaturedContent.dynamicContent = this.dynamicContent;

    FeaturedContent.hide = this.hide;

    this.loadMoreButton = $el.querySelector(
      '[data-scaction="GetMoreFeaturedContent"]'
    );

    if (this.loadMoreButton) {
      this.loadMoreButton.addEventListener("click", event => {
        event.preventDefault();
        this.loadMoreButton.disabled = true;
        this.loadMoreButton.setAttribute('aria-busy', true);
        this.GetMoreFeaturedContent();
      });
    }

    if (this.sort) {
      this.sort.addEventListener('change', event => {
        event.preventDefault();
        this.loadMoreButton.disabled = true;
        this.loadMoreButton.setAttribute('aria-busy', true);
        this.SortFeaturedContent(event.target.value);
      });
    }

    subscribe((data, { type, id, page }) => {
      if(window && window.location) {
        const url = new URL(window.location);
        if(!!id) {
          url.searchParams.set('id', id)
        } else {
          url.searchParams.delete('id')
        }
        window.history.replaceState(null, null, url);
      }

      if (['category', 'filter', 'sort'].includes(type)) {
        this.show()
        this.displayNewItems(data, false);
        this.setTitle(data);
        this.toggleAside(data);
      }

      if (type === 'loadmore') {
        this.displayNewItems(data, true);
      }

      this.toggleNoResults(data.TotalNumberOfResults === 0);
      this.id = id;
      this.page = page;
      this.component.dataset.contentCentreHomepage = !id;

      if (this.loadMoreButton) {
        this.loadMoreButton.disabled = !data.HasNextPage;
        this.loadMoreButton.setAttribute('aria-busy', false);
        this.setLoadMoreVisibility(data.HasNextPage);
      }

    });

    const lightboxOptions = {
      selector: 'data-glightbox',
      preload: false,
      autoplayVideos: true,
      touchNavigation: false,
      keyboardNavigation: false,
      draggable: false,
      skin: 'clean c-featured-content-lightbox'
      // hiding navigation is done via css glightbox-clean c-featured-content-lightbox
    }

    this.lightbox = GLightbox(lightboxOptions);
  }

  toggleAside({ MainCategory, Years }){
    const showAside = MainCategory && MainCategory.Categories && MainCategory.Categories.length >= 1 && Years && Years.length >= 0;

    this.asideContainer.setAttribute('aria-expanded', showAside);
  }

  setTitle({ MainCategory }){
    this.headingContainer.innerHTML = MainCategory && MainCategory.Name
      ? MainCategory.Name
      : get('default-title')
  }

  displayNewItems(data, shouldAppend) {
    const templateContainer = document.createElement('template');
    templateContainer.innerHTML = data.Items.map(item => {
      let renderer = templates.itemDefault;
      switch (item.Category.ContentType) {
        case 'Video': renderer = templates.itemVideo; break;
        case 'Image': renderer = templates.itemImage; break;
        case 'SocialMedia': renderer = templates.itemSocial; break;
        case 'Events': renderer = templates.itemEvent; break;
        case 'Downloads': renderer = templates.itemDownload; break;
        case 'Products': renderer = templates.itemProduct; break;
      }

      return renderer(item);
    }).join('');

    if (shouldAppend) {
      this.itemsContainer.appendChild(templateContainer.content);
    }
    else {
      this.itemsContainer.replaceChildren(templateContainer.content);
    }

    this.show();
    this.initEventItems();

    // reinitialise lightbox
    this.lightbox.reload();
  }

  toggleNoResults(shouldShow) {
    const ariaHidden = 'aria-hidden'
    const hidden = !shouldShow

    if(this.noResults.getAttribute(ariaHidden) === hidden) return

    this.noResults.setAttribute(ariaHidden, hidden)

    this.show();
  }

  GetMoreFeaturedContent() {
    const pageSize = FeaturedContent.pageSize();
    navigate({
      id: this.id,
      page: this.page + 1,
      pageSize,
      type: 'loadmore',
    }, collectFilters(), collectSort());
  }

  SortFeaturedContent(sortValue = collectSort(), filterValues = collectFilters()) {
    const pageSize = FeaturedContent.pageSize();
    FeaturedContent.hide();
    navigate({
      id: this.id,
      page: 1,
      pageSize,
      type: 'sort',
    }, filterValues, sortValue);
  }

  hide() {
    FeaturedContent.dynamicContent.forEach(element => element.classList.add('c-featured-content--hidden'))
    FeaturedContent.loader.classList.remove('c-loader-overlay--hidden')
  }

  show() {
    FeaturedContent.dynamicContent.forEach(element => element.classList.remove('c-featured-content--hidden'))
    FeaturedContent.loader.classList.add('c-loader-overlay--hidden')
  }

  setLoadMoreVisibility(visible) {
    this.loadMoreButton.style.display = visible ? '' : 'none';
  }

  static isContentCentrePage() {
    return !!document.querySelector(`${selectors.component} ${selectors.items}`);
  }

  static pageSize() {
    return get('items-per-page')
  }

  initEventItems() {
    this.itemsContainer.querySelectorAll(featuredItemEventSelector).forEach($el => new FeaturedItemEvent($el));
  }
}

document.querySelectorAll(selectors.component).forEach($el => new FeaturedContent($el));
